import axios from 'axios';

export const baseAPIEndPoint = 'https://estateapi.deltaesolution.com/'

const API = axios.create({
  baseURL: baseAPIEndPoint,
  timeout: 15000, 
  headers: {
    'Content-Type': 'application/json',
  },
});

API.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default API;
